import React, { Fragment } from 'react'
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemPanel,
    AccordionItemButton
} from 'react-accessible-accordion';
import {content} from '../../utils/content'



class Content extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        return (
            <Fragment>
                <Accordion allowZeroExpanded={true}>
                {
                    content.faq.map((n, key) => {
                        return (
                            <Fragment >
                                <h3>{n.heading}</h3>
                                    {
                                        n.content.map((o, kkey) => {
                                            return (
                                                <Fragment>
                                                    <AccordionItem key={kkey}>
                                                        <AccordionItemHeading>
                                                            <AccordionItemButton>{o.title}</AccordionItemButton>
                                                        </AccordionItemHeading>
                                                        <AccordionItemPanel>
                                                            {
                                                                o.content.map((p, kkkey) => {
                                                                    return (
                                                                        <p key={kkkey} dangerouslySetInnerHTML={{__html: p }}/>
                                                                    )
                                                                })
                                                            }
                                                        </AccordionItemPanel>
                                                    </AccordionItem>
                                                </Fragment>
                                            )   
                                        })
                                    }
                            </Fragment>
                        )
                    })
                }
                </Accordion>
                
            </Fragment>
        )
    }
}

export default Content;